import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { get, put } from '../../services/api'; // Ваш api.js

import ErrorMessage from '../../components/common/ErrorMessage/ErrorMessage';
import SettingsListItem from '../../components/Settings/SettingsListItem/SettingsListItem';
import styles from './LanguageSelectionPage.module.css';
import { useIntl, FormattedMessage } from 'react-intl';
import { FiCheck } from 'react-icons/fi';
import {useAuth} from "../../contexts/AuthContext";
import Title from "../../components/common/Title/Title";
import {usePageLoader} from "../../contexts/PageLoaderContext";
import {useNotifier} from "../../contexts/NotificationContext";
import {hideBackButton, showBackButton} from "../../services/telegramService"; // Для отметки выбранного языка

const LanguageSelectionPage = () => {
    const intl = useIntl();
    const navigate = useNavigate();
    const { user, refreshUser } = useAuth();

    const [languagesData, setLanguagesData] = useState(null);
    const [error, setError] = useState(null);

    const { showPageLoader, hidePageLoader } = usePageLoader();
    const { addNotification } = useNotifier();

    useEffect(() => {
        showBackButton();
    }, []);

    useEffect(() => {
        const fetchLanguages = async () => {
            showPageLoader();
            setError(null);
            try {
                const response = await get('languages'); // GET /languages
                if (response.success && response.data) {
                    setLanguagesData(response.data);
                } else {
                    throw new Error(response.message || intl.formatMessage({ id: "languagePage.loadingError" }));
                }
            } catch (err) {
                setError(err.message || intl.formatMessage({ id: "languagePage.loadingError" }));
            } finally {
                hidePageLoader();
            }
        };
        fetchLanguages();
    }, [intl]);

    const handleLanguageSelect = async (langKey) => {
        showPageLoader();
        setError(null);
        try {
            const response = await put('languages', { language: langKey }); // PUT /languages
            if (response.success) {
                await refreshUser();
                addNotification(response.message || intl.formatMessage({ id: 'languagePage.submitSuccess' }), 'success');
                navigate('/settings'); // Возвращаемся на страницу настроек
            } else {
                throw new Error(response.message || intl.formatMessage({ id: "languagePage.submitError" }));
            }
        } catch (err) {
            setError(err.message || intl.formatMessage({ id: "languagePage.submitError" }));
        } finally {
            hidePageLoader();
        }
    };

    return (
        <div className={styles.pageContainer}>
            <Title><FormattedMessage id="languagePage.title" /></Title>
            {error && <ErrorMessage message={error} onDismiss={() => setError(null)} />}

            <div className={styles.languageList}>
                {languagesData && Object.entries(languagesData).map(([langKey, langDetails]) => (
                    <SettingsListItem
                        key={langKey}
                        title={langDetails.title_en === langDetails.title ? langDetails.title : `${langDetails.title_en} (${langDetails.title})`} // Показываем оба названия, если они разные
                        onClick={() => handleLanguageSelect(langKey)}
                        currentValue={user.lang === langKey ? <FiCheck className={styles.checkIcon} /> : ''}
                    />
                ))}
            </div>
        </div>
    );
};

export default LanguageSelectionPage;
